import { render, staticRenderFns } from "./mirrorListDetails.vue?vue&type=template&id=bf94d3ec&scoped=true"
import script from "./mirrorListDetails.vue?vue&type=script&lang=js"
export * from "./mirrorListDetails.vue?vue&type=script&lang=js"
import style0 from "./mirrorListDetails.vue?vue&type=style&index=0&id=bf94d3ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf94d3ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf94d3ec')) {
      api.createRecord('bf94d3ec', component.options)
    } else {
      api.reload('bf94d3ec', component.options)
    }
    module.hot.accept("./mirrorListDetails.vue?vue&type=template&id=bf94d3ec&scoped=true", function () {
      api.rerender('bf94d3ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/imageManagement/mirrorListDetails.vue"
export default component.exports